import { Button, ButtonProps } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const   CbImportButton = ({
  name = "",
  className = "",
  style: externalStyles = {},
  ...props
}: ButtonProps) => {
  return (
    <Button
      {...props}
      className={`${className}`}
      style={{
        ...externalStyles,
      }}
      // styles={{ icon: { marginInlineEnd: 0 } }}
      icon={<UploadOutlined />}
    >
      {name}
    </Button>
  );
};
export default CbImportButton;
